import React from 'react';

const RecommendationSection = ({ value, assignedTo, onRecommendationChange, onAssignedToChange }) => {
  const teams = [
    'Safety Team A',
    'Safety Team B',
    'Maintenance Team',
    'Engineering Team',
    'Operations Team'
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Recommendations & Assignment</h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Recommended Corrective Actions
          </label>
          <textarea
            value={value}
            onChange={(e) => onRecommendationChange(e?.target?.value)}
            placeholder="Provide structured improvement suggestions and corrective action recommendations..."
            className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-none"
            rows={4}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Assign To
          </label>
          <select
            value={assignedTo}
            onChange={(e) => onAssignedToChange(e?.target?.value)}
            className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="">Auto-assign based on observation type...</option>
            {teams?.map((team) => (
              <option key={team} value={team}>{team}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default RecommendationSection;